import * as Sentry from '@sentry/react';
import { getCurrentEnvironment } from 'config/environment';
import { environmentConfigs } from './config';

export function initializeSentry() {
  try {
    const currentEnv = getCurrentEnvironment();
    const config = environmentConfigs[currentEnv];

    if (currentEnv === 'development') {
      console.log('Sentry для локальной разработки выключен');

      return;
    }

    console.log(`Initializing Sentry for environment: ${currentEnv}`);

    Sentry.init({
      dsn: config.dsn,
      environment: config.environment,
      sendDefaultPii: config.sendDefaultPii,
      debug: config.debug,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: config.tracesSampleRate,
      replaysSessionSampleRate: config.replaysSessionSampleRate,
      replaysOnErrorSampleRate: config.replaysOnErrorSampleRate,

      beforeSend(event) {
        if (
          config.environment === 'production' &&
          ['info', 'debug'].includes(event.level || '')
        ) {
          return null;
        }

        return event;
      },
      beforeBreadcrumb(breadcrumb) {
        if (
          config.environment === 'production' &&
          breadcrumb.category === 'console' &&
          breadcrumb.level !== 'error'
        ) {
          return null;
        }

        return breadcrumb;
      },
    });

    Sentry.setTag('deployment.environment', config.environment);
  } catch (error) {
    console.error('Error initializing Sentry:', error);
  }
}
